export const AVG_BUY_PRICES_NEU_BESTAND = [
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7582.501509233,
    mittl_preis_qm_kauf_bestand: 4823.0917618548,
    zeit: '2023-Q4',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 10992.0142836973,
    mittl_preis_qm_kauf_bestand: 6436.4937360696,
    zeit: '2023-Q4',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_neubau: 7114.7366110777,
    mittl_preis_qm_kauf_bestand: 4384.7525669643,
    zeit: '2023-Q4',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7272.4498850029,
    mittl_preis_qm_kauf_bestand: 3962.2705282765,
    zeit: '2023-Q4',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 9274.3874188591,
    mittl_preis_qm_kauf_bestand: 6403.7092242444,
    zeit: '2023-Q4',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 6700.9482797476,
    mittl_preis_qm_kauf_bestand: 3780.7335281949,
    zeit: '2023-Q4',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_neubau: 5270.2977050781,
    mittl_preis_qm_kauf_bestand: 3824.6160248105,
    zeit: '2023-Q4',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_neubau: 8501.5643469769,
    mittl_preis_qm_kauf_bestand: 5146.4962728283,
    zeit: '2023-Q4',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 7175.8603639764,
    mittl_preis_qm_kauf_bestand: 4307.3067133477,
    zeit: '2023-Q4',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_neubau: 8542.5340700011,
    mittl_preis_qm_kauf_bestand: 5206.5114381068,
    zeit: '2023-Q4',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_neubau: 9732.7046826172,
    mittl_preis_qm_kauf_bestand: 6076.6326691786,
    zeit: '2023-Q4',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7443.8139209153,
    mittl_preis_qm_kauf_bestand: 5755.3019150271,
    zeit: '2023-Q4',
  },
  {
    name: 'Friedrichshain',
    mittl_preis_qm_kauf_neubau: 9441.1360212054,
    mittl_preis_qm_kauf_bestand: 5838.1454537661,
    zeit: '2023-Q4',
  },
  {
    name: 'Tempelhof',
    mittl_preis_qm_kauf_neubau: 6688.505065918,
    mittl_preis_qm_kauf_bestand: 4814.3473808821,
    zeit: '2023-Q4',
  },
  {
    name: 'Wedding',
    mittl_preis_qm_kauf_neubau: 7618.1972384983,
    mittl_preis_qm_kauf_bestand: 4393.3498828125,
    zeit: '2023-Q4',
  },
  {
    name: 'Kreuzberg',
    mittl_preis_qm_kauf_neubau: 10166.1116446036,
    mittl_preis_qm_kauf_bestand: 6559.072996412,
    zeit: '2023-Q4',
  },
  {
    name: 'Charlottenburg',
    mittl_preis_qm_kauf_neubau: 10234.4179342831,
    mittl_preis_qm_kauf_bestand: 6642.7720407557,
    zeit: '2023-Q4',
  },
  {
    name: 'Köpenick',
    mittl_preis_qm_kauf_neubau: 7654.8025663642,
    mittl_preis_qm_kauf_bestand: 4539.414652704,
    zeit: '2023-Q4',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 8129.225402832,
    mittl_preis_qm_kauf_bestand: 5309.6723853845,
    zeit: '2023-Q4',
  },
  {
    name: 'Steglitz',
    mittl_preis_qm_kauf_neubau: 8046.3087158203,
    mittl_preis_qm_kauf_bestand: 4997.242357732,
    zeit: '2023-Q4',
  },
  {
    name: 'Schöneberg',
    mittl_preis_qm_kauf_neubau: 11861.9095299762,
    mittl_preis_qm_kauf_bestand: 5704.538002601,
    zeit: '2023-Q4',
  },
  {
    name: 'Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 12705.0065312206,
    mittl_preis_qm_kauf_bestand: 6366.6113149186,
    zeit: '2023-Q4',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 11666.1009928385,
    mittl_preis_qm_kauf_bestand: 8062.4520571108,
    zeit: '2023-Q4',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7213.524813088,
    mittl_preis_qm_kauf_bestand: 3832.3846635726,
    zeit: '2023-Q4',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7756.4426824396,
    mittl_preis_qm_kauf_bestand: 4972.2849759049,
    zeit: '2023-Q4',
  },
  {
    name: 'Zehlendorf',
    mittl_preis_qm_kauf_neubau: 10149.0999966325,
    mittl_preis_qm_kauf_bestand: 4937.8688375962,
    zeit: '2023-Q4',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 8041.673046875,
    mittl_preis_qm_kauf_bestand: 4279.9423588771,
    zeit: '2023-Q4',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 7042.7154947917,
    mittl_preis_qm_kauf_bestand: 3937.871560233,
    zeit: '2023-Q4',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7614.4161592371,
    mittl_preis_qm_kauf_bestand: 4916.8942473,
    zeit: '2023-Q3',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 11312.2614200125,
    mittl_preis_qm_kauf_bestand: 6420.459491875,
    zeit: '2023-Q3',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_neubau: 7252.0258144803,
    mittl_preis_qm_kauf_bestand: 4397.4205365205,
    zeit: '2023-Q3',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7400.3811383929,
    mittl_preis_qm_kauf_bestand: 4061.1820860746,
    zeit: '2023-Q3',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 9549.322501347,
    mittl_preis_qm_kauf_bestand: 6523.1790815673,
    zeit: '2023-Q3',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 6768.3162894871,
    mittl_preis_qm_kauf_bestand: 3820.0342171447,
    zeit: '2023-Q3',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_neubau: 5311.0250617825,
    mittl_preis_qm_kauf_bestand: 3808.1809008049,
    zeit: '2023-Q3',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_neubau: 8562.4095810146,
    mittl_preis_qm_kauf_bestand: 5124.5571276564,
    zeit: '2023-Q3',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 7175.2100269215,
    mittl_preis_qm_kauf_bestand: 4309.0464281278,
    zeit: '2023-Q3',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_neubau: 8428.7392331933,
    mittl_preis_qm_kauf_bestand: 5188.9532740148,
    zeit: '2023-Q3',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_neubau: 9717.7548626204,
    mittl_preis_qm_kauf_bestand: 6203.3931910313,
    zeit: '2023-Q3',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7681.0064714957,
    mittl_preis_qm_kauf_bestand: 5808.7018902231,
    zeit: '2023-Q3',
  },
  {
    name: 'Friedrichshain',
    mittl_preis_qm_kauf_neubau: 9613.3444149926,
    mittl_preis_qm_kauf_bestand: 5988.0094461403,
    zeit: '2023-Q3',
  },
  {
    name: 'Tempelhof',
    mittl_preis_qm_kauf_neubau: 5673.232421875,
    mittl_preis_qm_kauf_bestand: 4474.5443920379,
    zeit: '2023-Q3',
  },
  {
    name: 'Wedding',
    mittl_preis_qm_kauf_neubau: 7591.0888061523,
    mittl_preis_qm_kauf_bestand: 4414.6183035714,
    zeit: '2023-Q3',
  },
  {
    name: 'Kreuzberg',
    mittl_preis_qm_kauf_neubau: 10156.301940918,
    mittl_preis_qm_kauf_bestand: 6698.7082136287,
    zeit: '2023-Q3',
  },
  {
    name: 'Charlottenburg',
    mittl_preis_qm_kauf_neubau: 9715.6535456731,
    mittl_preis_qm_kauf_bestand: 6544.1324972477,
    zeit: '2023-Q3',
  },
  {
    name: 'Köpenick',
    mittl_preis_qm_kauf_neubau: 7726.6661542728,
    mittl_preis_qm_kauf_bestand: 4585.8664324505,
    zeit: '2023-Q3',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7892.0784442608,
    mittl_preis_qm_kauf_bestand: 5429.8031093838,
    zeit: '2023-Q3',
  },
  {
    name: 'Steglitz',
    mittl_preis_qm_kauf_neubau: 8169.9571475074,
    mittl_preis_qm_kauf_bestand: 5071.2460250289,
    zeit: '2023-Q3',
  },
  {
    name: 'Schöneberg',
    mittl_preis_qm_kauf_neubau: 11567.3121880425,
    mittl_preis_qm_kauf_bestand: 5757.6093224634,
    zeit: '2023-Q3',
  },
  {
    name: 'Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 13252.6978231402,
    mittl_preis_qm_kauf_bestand: 6343.6046041019,
    zeit: '2023-Q3',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 10703.2544555664,
    mittl_preis_qm_kauf_bestand: 8189.2774977534,
    zeit: '2023-Q3',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7009.4487783395,
    mittl_preis_qm_kauf_bestand: 3949.6949192059,
    zeit: '2023-Q3',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7759.3463541667,
    mittl_preis_qm_kauf_bestand: 5384.0944360352,
    zeit: '2023-Q3',
  },
  {
    name: 'Zehlendorf',
    mittl_preis_qm_kauf_neubau: 9952.9252672697,
    mittl_preis_qm_kauf_bestand: 5061.6316561071,
    zeit: '2023-Q3',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 7896.0521918403,
    mittl_preis_qm_kauf_bestand: 4296.5496531519,
    zeit: '2023-Q3',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 7033.6488715278,
    mittl_preis_qm_kauf_bestand: 3961.2586160622,
    zeit: '2023-Q3',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7215.291087963,
    mittl_preis_qm_kauf_bestand: 5032.2145833333,
    zeit: '2023-Q2',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 11844.1492183198,
    mittl_preis_qm_kauf_bestand: 6540.81372878,
    zeit: '2023-Q2',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_neubau: 7134.5183400926,
    mittl_preis_qm_kauf_bestand: 4512.7682036429,
    zeit: '2023-Q2',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7701.7474181293,
    mittl_preis_qm_kauf_bestand: 4260.4599532631,
    zeit: '2023-Q2',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 9579.0042414879,
    mittl_preis_qm_kauf_bestand: 6517.1504148582,
    zeit: '2023-Q2',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 6917.5889442845,
    mittl_preis_qm_kauf_bestand: 4057.3325607757,
    zeit: '2023-Q2',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_neubau: 5220.6125578704,
    mittl_preis_qm_kauf_bestand: 3864.6632929935,
    zeit: '2023-Q2',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_neubau: 8743.491394043,
    mittl_preis_qm_kauf_bestand: 5342.4383738423,
    zeit: '2023-Q2',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 6945.3765285326,
    mittl_preis_qm_kauf_bestand: 4315.0286397079,
    zeit: '2023-Q2',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_neubau: 8331.3682133009,
    mittl_preis_qm_kauf_bestand: 5165.4079758443,
    zeit: '2023-Q2',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_neubau: 9855.1811051569,
    mittl_preis_qm_kauf_bestand: 6293.2424050761,
    zeit: '2023-Q2',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7882.2746947869,
    mittl_preis_qm_kauf_bestand: 5881.5987605198,
    zeit: '2023-Q2',
  },
  {
    name: 'Friedrichshain',
    mittl_preis_qm_kauf_neubau: 9766.2441806481,
    mittl_preis_qm_kauf_bestand: 6072.0951443075,
    zeit: '2023-Q2',
  },
  {
    name: 'Tempelhof',
    mittl_preis_qm_kauf_neubau: null,
    mittl_preis_qm_kauf_bestand: 4571.375140904,
    zeit: '2023-Q2',
  },
  {
    name: 'Wedding',
    mittl_preis_qm_kauf_neubau: 7567.5610894097,
    mittl_preis_qm_kauf_bestand: 4465.7036019498,
    zeit: '2023-Q2',
  },
  {
    name: 'Kreuzberg',
    mittl_preis_qm_kauf_neubau: 10244.305507115,
    mittl_preis_qm_kauf_bestand: 6815.2575395563,
    zeit: '2023-Q2',
  },
  {
    name: 'Charlottenburg',
    mittl_preis_qm_kauf_neubau: 10833.1164171007,
    mittl_preis_qm_kauf_bestand: 6793.6794551773,
    zeit: '2023-Q2',
  },
  {
    name: 'Köpenick',
    mittl_preis_qm_kauf_neubau: 7809.5859949449,
    mittl_preis_qm_kauf_bestand: 4679.0541299673,
    zeit: '2023-Q2',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7871.9173519737,
    mittl_preis_qm_kauf_bestand: 5579.2618826984,
    zeit: '2023-Q2',
  },
  {
    name: 'Steglitz',
    mittl_preis_qm_kauf_neubau: 8098.5428292411,
    mittl_preis_qm_kauf_bestand: 5188.4385401408,
    zeit: '2023-Q2',
  },
  {
    name: 'Schöneberg',
    mittl_preis_qm_kauf_neubau: 11843.6187263258,
    mittl_preis_qm_kauf_bestand: 5816.8973807541,
    zeit: '2023-Q2',
  },
  {
    name: 'Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 14529.8268241313,
    mittl_preis_qm_kauf_bestand: 6454.4236340351,
    zeit: '2023-Q2',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 10840.7410933883,
    mittl_preis_qm_kauf_bestand: 8303.8746126792,
    zeit: '2023-Q2',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7312.4009540264,
    mittl_preis_qm_kauf_bestand: 4194.3613936452,
    zeit: '2023-Q2',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7704.6562613554,
    mittl_preis_qm_kauf_bestand: 5455.577978972,
    zeit: '2023-Q2',
  },
  {
    name: 'Zehlendorf',
    mittl_preis_qm_kauf_neubau: 10147.7969726562,
    mittl_preis_qm_kauf_bestand: 5351.3902369697,
    zeit: '2023-Q2',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 6897.9686889648,
    mittl_preis_qm_kauf_bestand: 4577.986309345,
    zeit: '2023-Q2',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 6786.3021918403,
    mittl_preis_qm_kauf_bestand: 4212.7913517147,
    zeit: '2023-Q2',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7290.5774031929,
    mittl_preis_qm_kauf_bestand: 5018.3446003542,
    zeit: '2023-Q1',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 11718.8995589372,
    mittl_preis_qm_kauf_bestand: 6472.419813428,
    zeit: '2023-Q1',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_neubau: 7240.1075484664,
    mittl_preis_qm_kauf_bestand: 4475.1194087472,
    zeit: '2023-Q1',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7656.5706558228,
    mittl_preis_qm_kauf_bestand: 4298.1282711389,
    zeit: '2023-Q1',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 9317.2407513787,
    mittl_preis_qm_kauf_bestand: 6524.1097393242,
    zeit: '2023-Q1',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 7142.3319878472,
    mittl_preis_qm_kauf_bestand: 4007.3595850745,
    zeit: '2023-Q1',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_neubau: 5239.0248831955,
    mittl_preis_qm_kauf_bestand: 3939.2461688702,
    zeit: '2023-Q1',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_neubau: 8574.0322048611,
    mittl_preis_qm_kauf_bestand: 5390.1283925327,
    zeit: '2023-Q1',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 7456.5813964844,
    mittl_preis_qm_kauf_bestand: 4472.2451808351,
    zeit: '2023-Q1',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_neubau: 8036.0956597222,
    mittl_preis_qm_kauf_bestand: 5220.6848739365,
    zeit: '2023-Q1',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_neubau: 9902.4541125971,
    mittl_preis_qm_kauf_bestand: 6223.6423602069,
    zeit: '2023-Q1',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 8001.8249347272,
    mittl_preis_qm_kauf_bestand: 5812.1712480534,
    zeit: '2023-Q1',
  },
  {
    name: 'Friedrichshain',
    mittl_preis_qm_kauf_neubau: 9861.4830322266,
    mittl_preis_qm_kauf_bestand: 5984.5596333272,
    zeit: '2023-Q1',
  },
  {
    name: 'Tempelhof',
    mittl_preis_qm_kauf_neubau: null,
    mittl_preis_qm_kauf_bestand: 4572.8947240857,
    zeit: '2023-Q1',
  },
  {
    name: 'Wedding',
    mittl_preis_qm_kauf_neubau: 8182.84375,
    mittl_preis_qm_kauf_bestand: 4422.5401449288,
    zeit: '2023-Q1',
  },
  {
    name: 'Kreuzberg',
    mittl_preis_qm_kauf_neubau: 9643.4930138221,
    mittl_preis_qm_kauf_bestand: 6742.0025803015,
    zeit: '2023-Q1',
  },
  {
    name: 'Charlottenburg',
    mittl_preis_qm_kauf_neubau: 11374.0881445312,
    mittl_preis_qm_kauf_bestand: 6820.3808486435,
    zeit: '2023-Q1',
  },
  {
    name: 'Köpenick',
    mittl_preis_qm_kauf_neubau: 8655.1669497283,
    mittl_preis_qm_kauf_bestand: 4666.941293667,
    zeit: '2023-Q1',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_neubau: 7945.1956176758,
    mittl_preis_qm_kauf_bestand: 5549.3309079363,
    zeit: '2023-Q1',
  },
  {
    name: 'Steglitz',
    mittl_preis_qm_kauf_neubau: 7835.716352983,
    mittl_preis_qm_kauf_bestand: 5147.2005984284,
    zeit: '2023-Q1',
  },
  {
    name: 'Schöneberg',
    mittl_preis_qm_kauf_neubau: 10932.6609002976,
    mittl_preis_qm_kauf_bestand: 5884.5501218249,
    zeit: '2023-Q1',
  },
  {
    name: 'Wilmersdorf',
    mittl_preis_qm_kauf_neubau: 11572.6135036355,
    mittl_preis_qm_kauf_bestand: 6479.0958596044,
    zeit: '2023-Q1',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_neubau: 9145.7366900276,
    mittl_preis_qm_kauf_bestand: 8508.470821193,
    zeit: '2023-Q1',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_neubau: 7353.2717603601,
    mittl_preis_qm_kauf_bestand: 4228.4461795867,
    zeit: '2023-Q1',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_neubau: 7601.6230294364,
    mittl_preis_qm_kauf_bestand: 5478.7160962976,
    zeit: '2023-Q1',
  },
  {
    name: 'Zehlendorf',
    mittl_preis_qm_kauf_neubau: 8998.2999441964,
    mittl_preis_qm_kauf_bestand: 5309.1512009954,
    zeit: '2023-Q1',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_neubau: 6831.5632595486,
    mittl_preis_qm_kauf_bestand: 4508.3101870888,
    zeit: '2023-Q1',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_neubau: 6499.5269042969,
    mittl_preis_qm_kauf_bestand: 4042.0463475357,
    zeit: '2023-Q1',
  },
  {
    mittl_preis_qm_kauf_neubau: 7373.161799,
    mittl_preis_qm_kauf_bestand: 4809.311448,
    zeit: '2021-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 7411.229639,
    mittl_preis_qm_kauf_bestand: 5818.357452,
    zeit: '2021-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 9414.655003,
    mittl_preis_qm_kauf_bestand: 5988.997173,
    zeit: '2021-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7373.748485,
    mittl_preis_qm_kauf_bestand: 4993.500539,
    zeit: '2021-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6619.407098,
    mittl_preis_qm_kauf_bestand: 4520.612729,
    zeit: '2021-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7796.273525,
    mittl_preis_qm_kauf_bestand: 4962.846074,
    zeit: '2021-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5233.245382,
    mittl_preis_qm_kauf_bestand: 3669.074711,
    zeit: '2021-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6665.691087,
    mittl_preis_qm_kauf_bestand: 3660.548721,
    zeit: '2021-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 9653.016666,
    mittl_preis_qm_kauf_bestand: 6111.972538,
    zeit: '2021-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 7386.981189,
    mittl_preis_qm_kauf_bestand: 4113.04409,
    zeit: '2021-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6843.095165,
    mittl_preis_qm_kauf_bestand: 4463.033698,
    zeit: '2021-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 11971.98828,
    mittl_preis_qm_kauf_bestand: 6282.185425,
    zeit: '2021-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 10826.83243,
    mittl_preis_qm_kauf_bestand: 6110.866491,
    zeit: '2021-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 7326.289646,
    mittl_preis_qm_kauf_bestand: 5629.732913,
    zeit: '2021-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 9299.117401,
    mittl_preis_qm_kauf_bestand: 5818.507096,
    zeit: '2021-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6864.326859,
    mittl_preis_qm_kauf_bestand: 5031.557485,
    zeit: '2021-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6573.416937,
    mittl_preis_qm_kauf_bestand: 4395.296812,
    zeit: '2021-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7108.296176,
    mittl_preis_qm_kauf_bestand: 4912.706443,
    zeit: '2021-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4846.066607,
    mittl_preis_qm_kauf_bestand: 3709.528828,
    zeit: '2021-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6533.719504,
    mittl_preis_qm_kauf_bestand: 3789.539402,
    zeit: '2021-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 9441.319877,
    mittl_preis_qm_kauf_bestand: 6059.90579,
    zeit: '2021-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 7275.684758,
    mittl_preis_qm_kauf_bestand: 3954.36559,
    zeit: '2021-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6429.307358,
    mittl_preis_qm_kauf_bestand: 4341.984294,
    zeit: '2021-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 7192.129539,
    mittl_preis_qm_kauf_bestand: 4747.214973,
    zeit: '2021-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 6831.193982,
    mittl_preis_qm_kauf_bestand: 4869.48145,
    zeit: '2021-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6934.620138,
    mittl_preis_qm_kauf_bestand: 5556.749101,
    zeit: '2021-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 8918.765573,
    mittl_preis_qm_kauf_bestand: 5768.536039,
    zeit: '2021-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6338.998871,
    mittl_preis_qm_kauf_bestand: 4199.491226,
    zeit: '2021-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7038.9204,
    mittl_preis_qm_kauf_bestand: 4878.769134,
    zeit: '2021-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5126.297863,
    mittl_preis_qm_kauf_bestand: 3731.90144,
    zeit: '2021-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6158.179766,
    mittl_preis_qm_kauf_bestand: 3673.358414,
    zeit: '2021-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 9030.19484,
    mittl_preis_qm_kauf_bestand: 5978.23669,
    zeit: '2021-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 6330.795502,
    mittl_preis_qm_kauf_bestand: 3947.334467,
    zeit: '2021-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6198.126774,
    mittl_preis_qm_kauf_bestand: 4159.109496,
    zeit: '2021-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 10462.50399,
    mittl_preis_qm_kauf_bestand: 5849.120949,
    zeit: '2021-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6675.355748,
    mittl_preis_qm_kauf_bestand: 4640.360228,
    zeit: '2021-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 6330.535021,
    mittl_preis_qm_kauf_bestand: 4453.091368,
    zeit: '2021-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 6292.492601,
    mittl_preis_qm_kauf_bestand: 5413.141248,
    zeit: '2021-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 8362.965332,
    mittl_preis_qm_kauf_bestand: 5576.91972,
    zeit: '2021-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6524.300026,
    mittl_preis_qm_kauf_bestand: 4758.980166,
    zeit: '2021-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6310.535527,
    mittl_preis_qm_kauf_bestand: 4105.826258,
    zeit: '2021-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6900.587346,
    mittl_preis_qm_kauf_bestand: 4792.161391,
    zeit: '2021-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5236.606155,
    mittl_preis_qm_kauf_bestand: 3645.345756,
    zeit: '2021-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5442.44364,
    mittl_preis_qm_kauf_bestand: 3549.008554,
    zeit: '2021-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8602.099447,
    mittl_preis_qm_kauf_bestand: 5847.982652,
    zeit: '2021-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 6108.221319,
    mittl_preis_qm_kauf_bestand: 3826.119886,
    zeit: '2021-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6009.984307,
    mittl_preis_qm_kauf_bestand: 4070.257124,
    zeit: '2021-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 9696.656457,
    mittl_preis_qm_kauf_bestand: 5830.773976,
    zeit: '2021-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 9061.498619,
    mittl_preis_qm_kauf_bestand: 5707.821845,
    zeit: '2020-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6171.728709,
    mittl_preis_qm_kauf_bestand: 5261.030747,
    zeit: '2020-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 8139.403814,
    mittl_preis_qm_kauf_bestand: 5495.282419,
    zeit: '2020-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6439.45571,
    mittl_preis_qm_kauf_bestand: 4619.090151,
    zeit: '2020-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6105.142428,
    mittl_preis_qm_kauf_bestand: 3937.084638,
    zeit: '2020-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7071.801409,
    mittl_preis_qm_kauf_bestand: 4692.924155,
    zeit: '2020-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4914.954174,
    mittl_preis_qm_kauf_bestand: 3088.38998,
    zeit: '2020-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5353.40918,
    mittl_preis_qm_kauf_bestand: 3311.246763,
    zeit: '2020-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 9208.502381,
    mittl_preis_qm_kauf_bestand: 5628.924351,
    zeit: '2020-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5653.341183,
    mittl_preis_qm_kauf_bestand: 3658.754662,
    zeit: '2020-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5703.612646,
    mittl_preis_qm_kauf_bestand: 3778.750217,
    zeit: '2020-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 6521.999301,
    mittl_preis_qm_kauf_bestand: 4209.665321,
    zeit: '2020-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5411.129689,
    mittl_preis_qm_kauf_bestand: 3642.331422,
    zeit: '2020-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5896.733546,
    mittl_preis_qm_kauf_bestand: 5141.340838,
    zeit: '2020-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7782.441677,
    mittl_preis_qm_kauf_bestand: 5285.296048,
    zeit: '2020-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6469.355664,
    mittl_preis_qm_kauf_bestand: 4257.421605,
    zeit: '2020-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 6074.810225,
    mittl_preis_qm_kauf_bestand: 4552.991712,
    zeit: '2020-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5927.916729,
    mittl_preis_qm_kauf_bestand: 3769.331599,
    zeit: '2020-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7150.317619,
    mittl_preis_qm_kauf_bestand: 4670.244834,
    zeit: '2020-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4585.79485,
    mittl_preis_qm_kauf_bestand: 3078.292972,
    zeit: '2020-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5171.156385,
    mittl_preis_qm_kauf_bestand: 3262.561356,
    zeit: '2020-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8907.695173,
    mittl_preis_qm_kauf_bestand: 5523.102181,
    zeit: '2020-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5685.165324,
    mittl_preis_qm_kauf_bestand: 3578.642702,
    zeit: '2020-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 8623.012745,
    mittl_preis_qm_kauf_bestand: 5674.89529,
    zeit: '2020-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4337.810419,
    mittl_preis_qm_kauf_bestand: 2969.562455,
    zeit: '2020-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5679.90989,
    mittl_preis_qm_kauf_bestand: 5020.139493,
    zeit: '2020-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7783.662477,
    mittl_preis_qm_kauf_bestand: 5239.397482,
    zeit: '2020-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5880.586297,
    mittl_preis_qm_kauf_bestand: 4508.341541,
    zeit: '2020-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5845.014859,
    mittl_preis_qm_kauf_bestand: 3763.930398,
    zeit: '2020-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7004.540988,
    mittl_preis_qm_kauf_bestand: 4657.111293,
    zeit: '2020-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5114.752399,
    mittl_preis_qm_kauf_bestand: 3219.077572,
    zeit: '2020-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8153.466114,
    mittl_preis_qm_kauf_bestand: 5516.88495,
    zeit: '2020-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5460.484532,
    mittl_preis_qm_kauf_bestand: 3579.288921,
    zeit: '2020-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5443.701928,
    mittl_preis_qm_kauf_bestand: 3546.345666,
    zeit: '2020-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 8283.745774,
    mittl_preis_qm_kauf_bestand: 5604.990764,
    zeit: '2020-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6230.538205,
    mittl_preis_qm_kauf_bestand: 4276.333811,
    zeit: '2020-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5671.895145,
    mittl_preis_qm_kauf_bestand: 4145.53333,
    zeit: '2020-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5403.640867,
    mittl_preis_qm_kauf_bestand: 4902.610983,
    zeit: '2020-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 8034.582733,
    mittl_preis_qm_kauf_bestand: 5250.657541,
    zeit: '2020-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5438.736588,
    mittl_preis_qm_kauf_bestand: 4479.294894,
    zeit: '2020-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5381.171083,
    mittl_preis_qm_kauf_bestand: 3703.939073,
    zeit: '2020-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 7107.019483,
    mittl_preis_qm_kauf_bestand: 4650.641854,
    zeit: '2020-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4549.341833,
    mittl_preis_qm_kauf_bestand: 2832.929346,
    zeit: '2020-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4725.845488,
    mittl_preis_qm_kauf_bestand: 3146.197349,
    zeit: '2020-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8336.073565,
    mittl_preis_qm_kauf_bestand: 5383.203267,
    zeit: '2020-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5194.986452,
    mittl_preis_qm_kauf_bestand: 3509.214956,
    zeit: '2020-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5739.153838,
    mittl_preis_qm_kauf_bestand: 3424.769383,
    zeit: '2020-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 8172.713001,
    mittl_preis_qm_kauf_bestand: 5488.186159,
    zeit: '2020-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 8201.811188,
    mittl_preis_qm_kauf_bestand: 5389.95169,
    zeit: '2019-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5365.159146,
    mittl_preis_qm_kauf_bestand: 4911.388745,
    zeit: '2019-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7504.401589,
    mittl_preis_qm_kauf_bestand: 5169.389977,
    zeit: '2019-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4934.246503,
    mittl_preis_qm_kauf_bestand: 4514.36912,
    zeit: '2019-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5269.068018,
    mittl_preis_qm_kauf_bestand: 3650.795752,
    zeit: '2019-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6721.929925,
    mittl_preis_qm_kauf_bestand: 4504.793585,
    zeit: '2019-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4548.883597,
    mittl_preis_qm_kauf_bestand: 2861.176102,
    zeit: '2019-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5273.182715,
    mittl_preis_qm_kauf_bestand: 3088.532164,
    zeit: '2019-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8056.188158,
    mittl_preis_qm_kauf_bestand: 5301.876986,
    zeit: '2019-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5178.49804,
    mittl_preis_qm_kauf_bestand: 3457.422098,
    zeit: '2019-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5560.403691,
    mittl_preis_qm_kauf_bestand: 3313.963257,
    zeit: '2019-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5222.504798,
    mittl_preis_qm_kauf_bestand: 4077.706192,
    zeit: '2019-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4948.783881,
    mittl_preis_qm_kauf_bestand: 4418.403101,
    zeit: '2019-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5301.478642,
    mittl_preis_qm_kauf_bestand: 4821.929537,
    zeit: '2019-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7662.859099,
    mittl_preis_qm_kauf_bestand: 5075.972641,
    zeit: '2019-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5134.111148,
    mittl_preis_qm_kauf_bestand: 3694.578734,
    zeit: '2019-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6527.104333,
    mittl_preis_qm_kauf_bestand: 4426.297106,
    zeit: '2019-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4242.736105,
    mittl_preis_qm_kauf_bestand: 2769.701448,
    zeit: '2019-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5218.202515,
    mittl_preis_qm_kauf_bestand: 3165.960171,
    zeit: '2019-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 8269.217839,
    mittl_preis_qm_kauf_bestand: 5243.510637,
    zeit: '2019-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5070.496432,
    mittl_preis_qm_kauf_bestand: 3423.128791,
    zeit: '2019-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5269.670296,
    mittl_preis_qm_kauf_bestand: 3319.04927,
    zeit: '2019-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 8378.153456,
    mittl_preis_qm_kauf_bestand: 5253.457414,
    zeit: '2019-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5436.965265,
    mittl_preis_qm_kauf_bestand: 4060.654918,
    zeit: '2019-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5456.281333,
    mittl_preis_qm_kauf_bestand: 3878.636219,
    zeit: '2019-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5177.817046,
    mittl_preis_qm_kauf_bestand: 4474.50674,
    zeit: '2019-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7448.512984,
    mittl_preis_qm_kauf_bestand: 4808.493623,
    zeit: '2019-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5305.344705,
    mittl_preis_qm_kauf_bestand: 4300.502747,
    zeit: '2019-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5022.415245,
    mittl_preis_qm_kauf_bestand: 3603.718258,
    zeit: '2019-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6547.998919,
    mittl_preis_qm_kauf_bestand: 4308.911347,
    zeit: '2019-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4025.205467,
    mittl_preis_qm_kauf_bestand: 2725.627952,
    zeit: '2019-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4588.499475,
    mittl_preis_qm_kauf_bestand: 2998.282513,
    zeit: '2019-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7810.952093,
    mittl_preis_qm_kauf_bestand: 5226.65333,
    zeit: '2019-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4435.003473,
    mittl_preis_qm_kauf_bestand: 3215.132729,
    zeit: '2019-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5073.334281,
    mittl_preis_qm_kauf_bestand: 3200.110143,
    zeit: '2019-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 8309.503059,
    mittl_preis_qm_kauf_bestand: 5169.094517,
    zeit: '2019-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 8394.361525,
    mittl_preis_qm_kauf_bestand: 5055.591957,
    zeit: '2019-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5149.923421,
    mittl_preis_qm_kauf_bestand: 4415.618108,
    zeit: '2019-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6965.613908,
    mittl_preis_qm_kauf_bestand: 4691.681887,
    zeit: '2019-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6212.805805,
    mittl_preis_qm_kauf_bestand: 3927.313949,
    zeit: '2019-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4904.301995,
    mittl_preis_qm_kauf_bestand: 3500.902529,
    zeit: '2019-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6646.740277,
    mittl_preis_qm_kauf_bestand: 4162.075756,
    zeit: '2019-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4262.141235,
    mittl_preis_qm_kauf_bestand: 2494.02791,
    zeit: '2019-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4486.215432,
    mittl_preis_qm_kauf_bestand: 2789.26523,
    zeit: '2019-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7700.354393,
    mittl_preis_qm_kauf_bestand: 5074.804548,
    zeit: '2019-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3697.077595,
    mittl_preis_qm_kauf_bestand: 3081.302507,
    zeit: '2019-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4682.583861,
    mittl_preis_qm_kauf_bestand: 3025.669438,
    zeit: '2019-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 6324.13864,
    mittl_preis_qm_kauf_bestand: 3820.554614,
    zeit: '2019-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4339.818542,
    mittl_preis_qm_kauf_bestand: 3012.823621,
    zeit: '2018-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5258.284979,
    mittl_preis_qm_kauf_bestand: 4234.498946,
    zeit: '2018-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 7009.007205,
    mittl_preis_qm_kauf_bestand: 4568.811795,
    zeit: '2018-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 8250.063605,
    mittl_preis_qm_kauf_bestand: 4912.471936,
    zeit: '2018-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6478.074447,
    mittl_preis_qm_kauf_bestand: 3737.759052,
    zeit: '2018-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4853.863341,
    mittl_preis_qm_kauf_bestand: 3432.70093,
    zeit: '2018-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6146.328682,
    mittl_preis_qm_kauf_bestand: 4037.638279,
    zeit: '2018-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5444.466254,
    mittl_preis_qm_kauf_bestand: 3719.243143,
    zeit: '2018-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4154.329976,
    mittl_preis_qm_kauf_bestand: 2416.075785,
    zeit: '2018-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4272.733038,
    mittl_preis_qm_kauf_bestand: 2697.783247,
    zeit: '2018-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7283.066635,
    mittl_preis_qm_kauf_bestand: 4814.426968,
    zeit: '2018-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4509.946813,
    mittl_preis_qm_kauf_bestand: 2971.169297,
    zeit: '2018-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5110.352894,
    mittl_preis_qm_kauf_bestand: 3593.868283,
    zeit: '2018-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 8088.068222,
    mittl_preis_qm_kauf_bestand: 4783.096334,
    zeit: '2018-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4521.66824,
    mittl_preis_qm_kauf_bestand: 2805.350388,
    zeit: '2018-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 4239.122412,
    mittl_preis_qm_kauf_bestand: 3036.202819,
    zeit: '2018-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 7297.051506,
    mittl_preis_qm_kauf_bestand: 4956.745105,
    zeit: '2018-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4386.079997,
    mittl_preis_qm_kauf_bestand: 2618.639998,
    zeit: '2018-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 3986.528564,
    mittl_preis_qm_kauf_bestand: 2312.448284,
    zeit: '2018-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6439.952734,
    mittl_preis_qm_kauf_bestand: 3855.793451,
    zeit: '2018-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4750.310336,
    mittl_preis_qm_kauf_bestand: 3412.773448,
    zeit: '2018-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6242.948625,
    mittl_preis_qm_kauf_bestand: 3725.268421,
    zeit: '2018-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6996.165621,
    mittl_preis_qm_kauf_bestand: 4456.11446,
    zeit: '2018-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4923.594282,
    mittl_preis_qm_kauf_bestand: 4169.757715,
    zeit: '2018-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 5266.881207,
    mittl_preis_qm_kauf_bestand: 3588.976289,
    zeit: '2018-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4864.307047,
    mittl_preis_qm_kauf_bestand: 4104.854785,
    zeit: '2018-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6693.201168,
    mittl_preis_qm_kauf_bestand: 4382.969874,
    zeit: '2018-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6249.724784,
    mittl_preis_qm_kauf_bestand: 3623.910947,
    zeit: '2018-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4685.922545,
    mittl_preis_qm_kauf_bestand: 3300.893795,
    zeit: '2018-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 6406.37407,
    mittl_preis_qm_kauf_bestand: 3733.500946,
    zeit: '2018-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3907.683329,
    mittl_preis_qm_kauf_bestand: 2269.122427,
    zeit: '2018-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4358.82628,
    mittl_preis_qm_kauf_bestand: 2459.463755,
    zeit: '2018-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7206.918935,
    mittl_preis_qm_kauf_bestand: 4694.497307,
    zeit: '2018-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4215.352905,
    mittl_preis_qm_kauf_bestand: 2963.151239,
    zeit: '2018-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4450.187795,
    mittl_preis_qm_kauf_bestand: 2726.212528,
    zeit: '2018-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 7769.493648,
    mittl_preis_qm_kauf_bestand: 4615.307948,
    zeit: '2018-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 7535.495551,
    mittl_preis_qm_kauf_bestand: 4449.1851,
    zeit: '2018-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4716.601763,
    mittl_preis_qm_kauf_bestand: 3962.593188,
    zeit: '2018-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6555.305582,
    mittl_preis_qm_kauf_bestand: 4326.875996,
    zeit: '2018-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5891.805253,
    mittl_preis_qm_kauf_bestand: 3525.416545,
    zeit: '2018-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4484.856244,
    mittl_preis_qm_kauf_bestand: 3136.080889,
    zeit: '2018-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5766.722204,
    mittl_preis_qm_kauf_bestand: 3650.588758,
    zeit: '2018-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3678.849121,
    mittl_preis_qm_kauf_bestand: 2399.112288,
    zeit: '2018-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4045.974976,
    mittl_preis_qm_kauf_bestand: 2433.986429,
    zeit: '2018-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7100.888855,
    mittl_preis_qm_kauf_bestand: 4605.602265,
    zeit: '2018-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3818.289964,
    mittl_preis_qm_kauf_bestand: 2871.2751,
    zeit: '2018-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4340.479798,
    mittl_preis_qm_kauf_bestand: 2782.786921,
    zeit: '2018-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5001.511916,
    mittl_preis_qm_kauf_bestand: 3620.14417,
    zeit: '2018-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5514.780211,
    mittl_preis_qm_kauf_bestand: 3377.6101,
    zeit: '2017-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4869.182603,
    mittl_preis_qm_kauf_bestand: 3837.801787,
    zeit: '2017-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6475.50793,
    mittl_preis_qm_kauf_bestand: 4163.609388,
    zeit: '2017-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4355.36238,
    mittl_preis_qm_kauf_bestand: 3068.921893,
    zeit: '2017-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5431.731015,
    mittl_preis_qm_kauf_bestand: 3504.146002,
    zeit: '2017-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3423.969614,
    mittl_preis_qm_kauf_bestand: 2461.96697,
    zeit: '2017-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3977.563555,
    mittl_preis_qm_kauf_bestand: 2233.614189,
    zeit: '2017-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 7114.607844,
    mittl_preis_qm_kauf_bestand: 4405.272755,
    zeit: '2017-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4023.151303,
    mittl_preis_qm_kauf_bestand: 2671.189808,
    zeit: '2017-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4341.726007,
    mittl_preis_qm_kauf_bestand: 2583.859404,
    zeit: '2017-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 7120.714579,
    mittl_preis_qm_kauf_bestand: 4306.593192,
    zeit: '2017-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4915.129248,
    mittl_preis_qm_kauf_bestand: 3494.018296,
    zeit: '2017-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5237.031477,
    mittl_preis_qm_kauf_bestand: 3307.335078,
    zeit: '2017-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4619.435283,
    mittl_preis_qm_kauf_bestand: 3792.717173,
    zeit: '2017-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6180.516405,
    mittl_preis_qm_kauf_bestand: 4180.285671,
    zeit: '2017-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4773.82628,
    mittl_preis_qm_kauf_bestand: 3319.266946,
    zeit: '2017-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4411.037768,
    mittl_preis_qm_kauf_bestand: 2961.979327,
    zeit: '2017-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5278.088699,
    mittl_preis_qm_kauf_bestand: 3448.802121,
    zeit: '2017-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3564.610343,
    mittl_preis_qm_kauf_bestand: 2327.062163,
    zeit: '2017-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4845.090923,
    mittl_preis_qm_kauf_bestand: 2223.044872,
    zeit: '2017-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 6984.186178,
    mittl_preis_qm_kauf_bestand: 4370.096402,
    zeit: '2017-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4863.051542,
    mittl_preis_qm_kauf_bestand: 2519.968174,
    zeit: '2017-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4482.041095,
    mittl_preis_qm_kauf_bestand: 2537.536693,
    zeit: '2017-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 6865.971155,
    mittl_preis_qm_kauf_bestand: 4155.445171,
    zeit: '2017-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 7078.434672,
    mittl_preis_qm_kauf_bestand: 4028.741916,
    zeit: '2017-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4581.298991,
    mittl_preis_qm_kauf_bestand: 3704.707331,
    zeit: '2017-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 5941.034247,
    mittl_preis_qm_kauf_bestand: 4121.597756,
    zeit: '2017-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4941.351502,
    mittl_preis_qm_kauf_bestand: 3265.288543,
    zeit: '2017-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4352.656548,
    mittl_preis_qm_kauf_bestand: 2912.926951,
    zeit: '2017-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5045.554659,
    mittl_preis_qm_kauf_bestand: 3328.934394,
    zeit: '2017-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3627.537851,
    mittl_preis_qm_kauf_bestand: 2197.135851,
    zeit: '2017-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3735.935162,
    mittl_preis_qm_kauf_bestand: 2161.229616,
    zeit: '2017-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 6839.865358,
    mittl_preis_qm_kauf_bestand: 4112.409332,
    zeit: '2017-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 5509.887835,
    mittl_preis_qm_kauf_bestand: 2403.63858,
    zeit: '2017-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4365.37678,
    mittl_preis_qm_kauf_bestand: 2439.482652,
    zeit: '2017-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5375.195839,
    mittl_preis_qm_kauf_bestand: 3100.038029,
    zeit: '2017-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4111.659725,
    mittl_preis_qm_kauf_bestand: 2282.623378,
    zeit: '2017-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 4410.208265,
    mittl_preis_qm_kauf_bestand: 3661.296164,
    zeit: '2017-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 6032.721748,
    mittl_preis_qm_kauf_bestand: 3962.625385,
    zeit: '2017-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4849.508892,
    mittl_preis_qm_kauf_bestand: 2954.003758,
    zeit: '2017-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4928.181224,
    mittl_preis_qm_kauf_bestand: 3199.451815,
    zeit: '2017-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4224.727286,
    mittl_preis_qm_kauf_bestand: 2552.233416,
    zeit: '2017-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4890.541212,
    mittl_preis_qm_kauf_bestand: 3159.438598,
    zeit: '2017-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3651.19041,
    mittl_preis_qm_kauf_bestand: 2084.195101,
    zeit: '2017-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3834.399992,
    mittl_preis_qm_kauf_bestand: 2115.932181,
    zeit: '2017-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 6719.99981,
    mittl_preis_qm_kauf_bestand: 3979.310095,
    zeit: '2017-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4953.18919,
    mittl_preis_qm_kauf_bestand: 2336.662539,
    zeit: '2017-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6856.511908,
    mittl_preis_qm_kauf_bestand: 3877.009919,
    zeit: '2017-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4444.793761,
    mittl_preis_qm_kauf_bestand: 2914.541196,
    zeit: '2016-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4307.245312,
    mittl_preis_qm_kauf_bestand: 3420.177432,
    zeit: '2016-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 5671.591666,
    mittl_preis_qm_kauf_bestand: 3796.391561,
    zeit: '2016-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5151.940313,
    mittl_preis_qm_kauf_bestand: 3087.624812,
    zeit: '2016-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4228.968318,
    mittl_preis_qm_kauf_bestand: 2545.562324,
    zeit: '2016-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5076.842386,
    mittl_preis_qm_kauf_bestand: 3077.115359,
    zeit: '2016-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3202.955662,
    mittl_preis_qm_kauf_bestand: 2070.977588,
    zeit: '2016-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3863.426143,
    mittl_preis_qm_kauf_bestand: 2037.786899,
    zeit: '2016-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 6479.023178,
    mittl_preis_qm_kauf_bestand: 3895.598562,
    zeit: '2016-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 4256.421963,
    mittl_preis_qm_kauf_bestand: 2238.924628,
    zeit: '2016-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3752.154187,
    mittl_preis_qm_kauf_bestand: 2227.836286,
    zeit: '2016-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 6713.8275,
    mittl_preis_qm_kauf_bestand: 3870.498846,
    zeit: '2016-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4593.943311,
    mittl_preis_qm_kauf_bestand: 2819.423488,
    zeit: '2016-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4269.69864,
    mittl_preis_qm_kauf_bestand: 3281.054084,
    zeit: '2016-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 5353.348527,
    mittl_preis_qm_kauf_bestand: 3692.031012,
    zeit: '2016-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4776.024476,
    mittl_preis_qm_kauf_bestand: 3020.939821,
    zeit: '2016-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3986.602193,
    mittl_preis_qm_kauf_bestand: 2285.47063,
    zeit: '2016-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 5072.335924,
    mittl_preis_qm_kauf_bestand: 3006.729532,
    zeit: '2016-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 2910.193648,
    mittl_preis_qm_kauf_bestand: 1960.303459,
    zeit: '2016-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3782.981727,
    mittl_preis_qm_kauf_bestand: 1999.196264,
    zeit: '2016-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 6072.757364,
    mittl_preis_qm_kauf_bestand: 3664.688903,
    zeit: '2016-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3349.377834,
    mittl_preis_qm_kauf_bestand: 2266.040691,
    zeit: '2016-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3432.559435,
    mittl_preis_qm_kauf_bestand: 2195.113565,
    zeit: '2016-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 6338.539049,
    mittl_preis_qm_kauf_bestand: 3799.767678,
    zeit: '2016-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 6059.126148,
    mittl_preis_qm_kauf_bestand: 3633.489773,
    zeit: '2016-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4257.365082,
    mittl_preis_qm_kauf_bestand: 3157.504779,
    zeit: '2016-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 5149.92223,
    mittl_preis_qm_kauf_bestand: 3589.501519,
    zeit: '2016-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4295.672175,
    mittl_preis_qm_kauf_bestand: 2943.431637,
    zeit: '2016-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3378.250776,
    mittl_preis_qm_kauf_bestand: 2143.052624,
    zeit: '2016-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4813.242666,
    mittl_preis_qm_kauf_bestand: 2840.626204,
    zeit: '2016-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 2744.139235,
    mittl_preis_qm_kauf_bestand: 1990.241908,
    zeit: '2016-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3817.93276,
    mittl_preis_qm_kauf_bestand: 1900.028537,
    zeit: '2016-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 5707.966399,
    mittl_preis_qm_kauf_bestand: 3601.766239,
    zeit: '2016-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3502.431627,
    mittl_preis_qm_kauf_bestand: 2186.648061,
    zeit: '2016-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3511.918152,
    mittl_preis_qm_kauf_bestand: 2128.529349,
    zeit: '2016-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 3670.23692,
    mittl_preis_qm_kauf_bestand: 2649.025196,
    zeit: '2016-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 5693.101453,
    mittl_preis_qm_kauf_bestand: 3520.608354,
    zeit: '2016-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4022.345845,
    mittl_preis_qm_kauf_bestand: 3093.559639,
    zeit: '2016-Q1',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 4826.350313,
    mittl_preis_qm_kauf_bestand: 3533.714859,
    zeit: '2016-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4601.386477,
    mittl_preis_qm_kauf_bestand: 2837.524919,
    zeit: '2016-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3308.35778,
    mittl_preis_qm_kauf_bestand: 2025.26604,
    zeit: '2016-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4589.634606,
    mittl_preis_qm_kauf_bestand: 2776.915114,
    zeit: '2016-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 2974.496663,
    mittl_preis_qm_kauf_bestand: 1917.081926,
    zeit: '2016-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3592.920349,
    mittl_preis_qm_kauf_bestand: 1787.886341,
    zeit: '2016-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 5582.804178,
    mittl_preis_qm_kauf_bestand: 3538.20322,
    zeit: '2016-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3535.27865,
    mittl_preis_qm_kauf_bestand: 2106.091642,
    zeit: '2016-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3458.066367,
    mittl_preis_qm_kauf_bestand: 2088.643466,
    zeit: '2016-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 3987.063494,
    mittl_preis_qm_kauf_bestand: 2469.369649,
    zeit: '2016-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 2977.3604,
    mittl_preis_qm_kauf_bestand: 1708.385096,
    zeit: '2015-Q4',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3725.963112,
    mittl_preis_qm_kauf_bestand: 3003.250037,
    zeit: '2015-Q4',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 4676.886193,
    mittl_preis_qm_kauf_bestand: 3389.216302,
    zeit: '2015-Q4',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4211.822014,
    mittl_preis_qm_kauf_bestand: 2659.803235,
    zeit: '2015-Q4',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3304.527094,
    mittl_preis_qm_kauf_bestand: 1925.642643,
    zeit: '2015-Q4',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4246.201314,
    mittl_preis_qm_kauf_bestand: 2764.676415,
    zeit: '2015-Q4',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3448.305699,
    mittl_preis_qm_kauf_bestand: 1695.511959,
    zeit: '2015-Q4',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 5468.87362,
    mittl_preis_qm_kauf_bestand: 3488.626148,
    zeit: '2015-Q4',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3224.924871,
    mittl_preis_qm_kauf_bestand: 1986.251064,
    zeit: '2015-Q4',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3406.869099,
    mittl_preis_qm_kauf_bestand: 2003.610648,
    zeit: '2015-Q4',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5570.927396,
    mittl_preis_qm_kauf_bestand: 3500.477931,
    zeit: '2015-Q4',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3788.245926,
    mittl_preis_qm_kauf_bestand: 2248.114143,
    zeit: '2015-Q4',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 3982.417052,
    mittl_preis_qm_kauf_bestand: 2175.833068,
    zeit: '2015-Q3',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 3560.889688,
    mittl_preis_qm_kauf_bestand: 2877.395593,
    zeit: '2015-Q3',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 4558.232184,
    mittl_preis_qm_kauf_bestand: 3277.203993,
    zeit: '2015-Q3',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3881.924349,
    mittl_preis_qm_kauf_bestand: 2572.757925,
    zeit: '2015-Q3',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3124.987105,
    mittl_preis_qm_kauf_bestand: 1834.865226,
    zeit: '2015-Q3',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4382.079956,
    mittl_preis_qm_kauf_bestand: 2761.829498,
    zeit: '2015-Q3',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3103.162361,
    mittl_preis_qm_kauf_bestand: 1656.645185,
    zeit: '2015-Q3',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3464.96748,
    mittl_preis_qm_kauf_bestand: 1631.321561,
    zeit: '2015-Q3',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 5334.319214,
    mittl_preis_qm_kauf_bestand: 3328.986486,
    zeit: '2015-Q3',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3377.260683,
    mittl_preis_qm_kauf_bestand: 1901.901166,
    zeit: '2015-Q3',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3421.666052,
    mittl_preis_qm_kauf_bestand: 1908.283661,
    zeit: '2015-Q3',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 5349.482071,
    mittl_preis_qm_kauf_bestand: 3418.348758,
    zeit: '2015-Q3',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5146.488571,
    mittl_preis_qm_kauf_bestand: 3373.826921,
    zeit: '2015-Q2',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3400.987641,
    mittl_preis_qm_kauf_bestand: 2825.296095,
    zeit: '2015-Q2',
    name: 'Pankow',
  },
  {
    mittl_preis_qm_kauf_neubau: 4414.286256,
    mittl_preis_qm_kauf_bestand: 3222.049115,
    zeit: '2015-Q2',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3540.613755,
    mittl_preis_qm_kauf_bestand: 2589.536448,
    zeit: '2015-Q2',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 2994.297203,
    mittl_preis_qm_kauf_bestand: 1806.994504,
    zeit: '2015-Q2',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4281.575068,
    mittl_preis_qm_kauf_bestand: 2650.405343,
    zeit: '2015-Q2',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 2789.42582,
    mittl_preis_qm_kauf_bestand: 1656.964513,
    zeit: '2015-Q2',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3190.168169,
    mittl_preis_qm_kauf_bestand: 1599.164128,
    zeit: '2015-Q2',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 5277.40446,
    mittl_preis_qm_kauf_bestand: 3410.201977,
    zeit: '2015-Q2',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3407.007671,
    mittl_preis_qm_kauf_bestand: 1848.249957,
    zeit: '2015-Q2',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3271.643963,
    mittl_preis_qm_kauf_bestand: 1885.45968,
    zeit: '2015-Q2',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 3288.659806,
    mittl_preis_qm_kauf_bestand: 2214.044654,
    zeit: '2015-Q2',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 4297.656414,
    mittl_preis_qm_kauf_bestand: 3098.15804,
    zeit: '2015-Q1',
    name: 'Friedrichshain-Kreuzberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 4928.662762,
    mittl_preis_qm_kauf_bestand: 3238.531554,
    zeit: '2015-Q1',
    name: 'Charlottenburg-Wilmersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3138.020541,
    mittl_preis_qm_kauf_bestand: 1861.002155,
    zeit: '2015-Q1',
    name: 'Treptow-Köpenick',
  },
  {
    mittl_preis_qm_kauf_neubau: 3271.915527,
    mittl_preis_qm_kauf_bestand: 1792.757226,
    zeit: '2015-Q1',
    name: 'Reinickendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 5015.340791,
    mittl_preis_qm_kauf_bestand: 3337.5112,
    zeit: '2015-Q1',
    name: 'Mitte',
  },
  {
    mittl_preis_qm_kauf_neubau: 3315.453323,
    mittl_preis_qm_kauf_bestand: 1530.89049,
    zeit: '2015-Q1',
    name: 'Spandau',
  },
  {
    mittl_preis_qm_kauf_neubau: 3225.405231,
    mittl_preis_qm_kauf_bestand: 2155.816359,
    zeit: '2015-Q1',
    name: 'Neukölln',
  },
  {
    mittl_preis_qm_kauf_neubau: 2483.321792,
    mittl_preis_qm_kauf_bestand: 1578.699543,
    zeit: '2015-Q1',
    name: 'Marzahn-Hellersdorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 4207.385808,
    mittl_preis_qm_kauf_bestand: 2500.479499,
    zeit: '2015-Q1',
    name: 'Steglitz-Zehlendorf',
  },
  {
    mittl_preis_qm_kauf_neubau: 3007.562898,
    mittl_preis_qm_kauf_bestand: 1822.620087,
    zeit: '2015-Q1',
    name: 'Lichtenberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3501.038922,
    mittl_preis_qm_kauf_bestand: 2318.605819,
    zeit: '2015-Q1',
    name: 'Tempelhof-Schöneberg',
  },
  {
    mittl_preis_qm_kauf_neubau: 3469.057493,
    mittl_preis_qm_kauf_bestand: 2762.349594,
    zeit: '2015-Q1',
    name: 'Pankow',
  },
]
